import { NumberInput, coerceNumberProperty } from '@angular/cdk/coercion';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { clamp } from 'lodash-es';

@Component({
  standalone: true,
  selector: 'aw-progress-bar',
  templateUrl: 'progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class ProgressBarComponent {
  @Input()
  set progress(_progress: NumberInput) {
    let progress = coerceNumberProperty(_progress);
    progress = Math.round(progress);
    progress = clamp(progress, 0, 100);

    this._progress = progress;
  }

  get progress(): number {
    return this._progress;
  }

  private _progress = 0;
}
